import { tableConstantsFactory } from './tableConstantsFactory';
const cabinetConstants = tableConstantsFactory('CABINET');
cabinetConstants.OPTIONS_INDEX = 'CABINET_OPTIONS_INDEX';
cabinetConstants.OPTIONS_PAGE_NEXT = 'CABINET_OPTIONS_PAGE_NEXT';
cabinetConstants.SET_CURRENT = 'CABINET_SET_CURRENT';
cabinetConstants.SET_SELECTED_VIEW = 'CABINET_SET_SELECTED_VIEW';
cabinetConstants.AI_REQUEST = 'CABINET_AI_REQUEST';
cabinetConstants.AI_SUCCESS = 'CABINET_AI_SUCCESS';
cabinetConstants.AI_ERROR = 'CABINET_AI_ERROR';
cabinetConstants.INDEX_COUNT_SUCCESS = 'CABINET_INDEX_COUNT_SUCCESS';
export default cabinetConstants;